module.exports = __webpack_public_path__ + "contratos-cancelados.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images2/icons/contratos-cancelados.png
 ** module id = 749
 ** module chunks = 0
 **/